import React, { useEffect, useState } from 'react';
import { usePostgrest } from 'src/services/postgrest-provider';
import { RequestStatus } from "src/shared/enums";
import { KnownUserRecord } from '../services/full-report';
import { ExposedUsers } from './ExposedUsers';

export const ExposedUsersWithApi:React.FC = () => {
  const postgrest = usePostgrest();
  const [reqStatus, setReqStatus] = useState(RequestStatus.Pending);
  const [data, setData] = useState([] as KnownUserRecord[]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => getData(), []);

  const getData = () => {
    postgrest
      .GetTable('known_users')
      .then((res) => {
        if (res.type === "success"){
          setReqStatus(RequestStatus.Success);
          setData(res.data);
        } else if (res.type === "error") {
          console.error(res.message);
          setReqStatus(RequestStatus.Error);
        }
      })
  }
  return (
    <ExposedUsers data={data} status={reqStatus} />
  )
}